import type { Rect } from '../../../engine/hex/types';
import type { ModalTheme } from '../ModalTheme';
import type { HitTarget, MeasureResult, UiItem } from './Types';

export class SpacerItem implements UiItem {
    private rect: Rect = { x: 0, y: 0, w: 0, h: 0 };
    constructor(private height: number) {}

    measure(_ctx: CanvasRenderingContext2D, maxW: number, _theme: ModalTheme): MeasureResult {
        return { w: maxW, h: this.height };
    }

    layout(x: number, y: number, w: number, _theme: ModalTheme): void {
        this.rect = { x, y, w, h: this.height };
    }

    draw(_ctx: CanvasRenderingContext2D, _theme: ModalTheme): void {}

    collectHitTargets(_out: HitTarget[], _scrollY: number): void {}
}
